/**
 * Which conversation is on screen, for a support report's "Agent".
 *
 * Each chat surface (the agent chat, the Agent of Agents, the Concierge, the
 * Guide) registers its open conversation while it is shown; the report sends
 * that id and nothing else. The server names the agent, and only from a
 * conversation the reporter may read (backend/modules/support_board).
 */

import { useEffect } from 'react';

let current: string | null = null;

export function currentSupportConversation(): string | null {
  return current;
}

/** Register `conversationId` as the one on screen while this component shows it. */
export function useSupportConversation(conversationId: string | null | undefined): void {
  useEffect(() => {
    if (!conversationId) return undefined;
    current = conversationId;
    return () => {
      if (current === conversationId) current = null;
    };
  }, [conversationId]);
}
